function initVideoSwiper(sectionId) {
  const swiperContainer = document.querySelector(".video-swiper-" + sectionId);
  if (!swiperContainer) return;

  const swiper = new Swiper(".video-swiper-" + sectionId, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    centeredSlides: true,
    loop: false,
    initialSlide: 0,
    breakpoints: {
      0: { slidesPerView: 1.2, spaceBetween: 16, centeredSlides: true },
      750: { slidesPerView: 2.2, spaceBetween: 20, centeredSlides: false },
      990: { slidesPerView: 3, spaceBetween: 20, centeredSlides: false },
      1200: { slidesPerView: 4, spaceBetween: 22, centeredSlides: false },
    },
    on: {
      slideChange: function () {
        document
          .querySelectorAll(".video-swiper-" + sectionId + " video")
          .forEach((video) => video.pause());
      },
    },
  });

  // Both sets of arrows (header on desktop, below the slides on mobile) go to
  // swiper-arrows.js, not Swiper's navigation, which disables the end arrow
  // and drops keyboard focus (TASKS #161).
  if (window.JiYuSwiperArrows) {
    window.JiYuSwiperArrows.wire(swiper, {
      prevEl: ".swiper-prev-" + sectionId,
      nextEl: ".swiper-next-" + sectionId,
    });
  }

  if (window.innerWidth < 750) {
    swiper.slideTo(1, 0);
  }

  const slides = document.querySelectorAll(
    ".video-swiper-" + sectionId + " .swiper-slide"
  );

  slides.forEach((slide) => {
    const video = slide.querySelector("video");
    const posterWrapper = slide.querySelector(".video-slide-poster");
    const playBtn = slide.querySelector(".video-slide-play-btn");
    const card = slide.querySelector(".video-slide-card") || slide;

    if (!video) return;

    const playIcon = playBtn ? playBtn.querySelector(".play-icon") : null;
    const pauseIcon = playBtn ? playBtn.querySelector(".pause-icon") : null;

    video.muted = false;
    video.volume = 1;
    video.load();

    const togglePlayPause = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      slides.forEach((otherSlide) => {
        const otherVideo = otherSlide.querySelector("video");
        const otherPoster = otherSlide.querySelector(".video-slide-poster");
        const otherBtn = otherSlide.querySelector(".video-slide-play-btn");

        if (otherVideo && otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
          if (otherPoster) otherPoster.classList.add("active");
          if (otherBtn) {
            const op = otherBtn.querySelector(".play-icon");
            const opa = otherBtn.querySelector(".pause-icon");
            if (op) op.style.display = "block";
            if (opa) opa.style.display = "none";
          }
        }
      });

      if (video.paused) {
        video
          .play()
          .then(() => {
            if (posterWrapper) posterWrapper.classList.remove("active");
            if (playIcon) playIcon.style.display = "none";
            if (pauseIcon) pauseIcon.style.display = "block";
          })
          .catch((err) => console.log("Play failed:", err));
      } else {
        video.pause();
        if (posterWrapper) posterWrapper.classList.add("active");
        if (playIcon) playIcon.style.display = "block";
        if (pauseIcon) pauseIcon.style.display = "none";
      }
    };

    if (playBtn) {
      playBtn.addEventListener("click", togglePlayPause);
    }

    card.addEventListener("click", (e) => {
      if (e.target.closest("a, button")) return;
      togglePlayPause(e);
    });

    video.addEventListener("play", () => {
      if (posterWrapper) posterWrapper.classList.remove("active");
      if (playIcon) playIcon.style.display = "none";
      if (pauseIcon) pauseIcon.style.display = "block";
    });

    video.addEventListener("pause", () => {
      if (posterWrapper) posterWrapper.classList.add("active");
      if (playIcon) playIcon.style.display = "block";
      if (pauseIcon) pauseIcon.style.display = "none";
    });

    video.addEventListener("ended", () => {
      if (posterWrapper) posterWrapper.classList.add("active");
      if (playIcon) playIcon.style.display = "block";
      if (pauseIcon) pauseIcon.style.display = "none";
    });
  });
}
